module.exports = __webpack_public_path__ + "static/media/selected_beach_marker.c09f1a70.svg";